<div>
  <div class="search-container">
    <div class="input-actions">
      <div class="input-container">
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (input)="applyFilter()"
          id="searchInput"
          [ngClass]="{ 'filled': searchTerm }"
        />
        <label for="searchInput"><span>{{ labelForSearch }}</span></label>
      </div>

      @if (editMode) {
        <div class="buttons-div">
          <button (click)="addSingle.emit()">Crear {{nameSeccion}}</button>
          <button (click)="addBulk.emit()">Crear carga masiva</button>
        </div>
      }
    </div>
  </div>


  @if (filterData.length) {
    <div class="table-wrapper">
      <table>
        <thead>
        <!-- <th class="selection-header">
          <input
            type="checkbox"
            [checked]="allSelected"
            (change)="toggleSelectAll()"
            style="accent-color: var(--primaryColor)"
          />
        </th> -->
          @for (col of columns; track col.key) {
            <th>{{ col.displayName }}</th>
          }
        </thead>
        <tbody>
          @for (item of paginatedData; track trackByIds($index, item)) {
            <tr>
              <!-- <td class="selection-cell">
                <input
                  type="checkbox"
                  [checked]="isSelected(item)"
                  (change)="toggleSelectItem(item)"
                  style="accent-color: var(--primaryColor)"
                />
              </td> -->

              @for (col of columns; track col.key) {
                <td>
                  @switch (col.key) {
                    @case ('acciones') {
                      <div class="actions-cell">
                        @if (item.id === editingId) {
                          <div class="buttons-div">
                            <button (click)="cancel()" title="Cancelar" class="btn-cancelar">Cancelar</button>
                            <button (click)="onSaveEdit(item)" title="Guardar" class="btn-guardar">Actualizar</button>
                          </div>
                        } @else {
                          <button (click)="startEdit(item)" title="Editar">
                            <img src="/assets/icons/edit.svg" alt="Editar" width="15" height="15" />
                          </button>
                          <button (click)="onDelete(item)" title="Eliminar">
                            <img src="/assets/icons/delete.svg" alt="Eliminar" width="24" height="24" />
                          </button>
                        }
                        @for (icon of actionsIcons; track icon.label) {
                      <button (click)="icon.action(item)" title="{{ icon.label }}" class="icon-button">
                        <img
                          src="/assets/icons/{{ icon.icon }}"
                          alt="{{ icon.label }}"
                          width="20"
                          height="20"
                        />
                      </button>
                      }
                      </div>
                    }
                    @default {
                      @if (item.id === editingId) {
                        <input [(ngModel)]="item[col.key]" class="input-edit"/>
                      } @else {
                        {{ item[col.key] }}
                      }
                    }
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
    <!-- Paginación -->
    <div class="pagination-footer">
      <div class="page-size-group">
        <label for="itemsPerPage">Por página</label>
        <select
          id="itemsPerPage"
          [(ngModel)]="itemsPerPage"
          (change)="onItemsPerPageChange()"
        >
          <option [value]="5">5</option>
          <option [value]="10">10</option>
          <option [value]="25">25</option>
          <option [value]="50">50</option>
        </select>
      </div>

      <span class="pagination-info">
       {{ (currentPage - 1) * itemsPerPage + 1 }}–{{ getEndItemIndex() }} de {{ totalItems }}
    </span>

      <div class="pagination-buttons">
        <button (click)="previousPage()" [disabled]="currentPage === 1">
          <img src="assets/botones-footer-table/anterior.svg" alt="Anterior">
        </button>
        <button (click)="nextPage()" [disabled]="currentPage === totalPages">
          <img src="assets/botones-footer-table/siguiente.svg" alt="Siguiente">
        </button>
      </div>
    </div>
  } @else {
    <div class="no-data">
      <span>No se encontraron registros</span>
    </div>
  }
</div>
